"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findMatchingOrDefaultDesign = void 0;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const either_1 = require("../../types/either");
const _1 = require(".");
/**
 * Finds a matching design from the new template designs based on the provided criteria.
 * If no exact match is found, it returns a default design or the first allowed design.
 *
 * The old template designs are used to reference the previous design (if provided) for
 * restrictions such as allowed pages and coverage. TODO: It seems to EE on 11/7/24 that we
 * should probably be passing in the page index and coverage instead of using the old
 * design to assume what the allowedPages should be.
 *
 * @param newTemplateDesigns - Array of new template designs to search within.
 * @param oldTemplateDesigns - Optional array of old template designs to reference.
 * @param designId - Optional ID of the design to match.
 * @param interiorPageCount - Optional number of interior pages to consider for restrictions.
 * @param printableGroupType - Optional type of printable group to filter designs.
 * @returns Either an Error or the matched/default design.
 */
const findMatchingOrDefaultDesign = _ref => {
  let {
    newTemplateDesigns,
    oldTemplateDesigns,
    designId,
    interiorPageCount,
    printableGroupType
  } = _ref;
  const oldDesign = oldTemplateDesigns === null || oldTemplateDesigns === void 0 ? void 0 : oldTemplateDesigns.find(design => design.id === designId);
  const {
    allowedPages,
    coverage
  } = oldDesign || {};
  let allowedDesigns = newTemplateDesigns;
  // Account for restrictions
  if (interiorPageCount && allowedPages) {
    const allowedDesignsResult = (0, _1.getAllowedDesigns)({
      allowedPages,
      interiorPageCount,
      designs: newTemplateDesigns,
      coverage
    });
    if (allowedDesignsResult.isLeft()) {
      return (0, either_1.left)(allowedDesignsResult.value);
    }
    allowedDesigns = allowedDesignsResult.value;
  }
  // Filter by printable group type
  if (printableGroupType) {
    allowedDesigns = allowedDesigns.filter(d => !d.allowedPrintableGroupTypes || d.allowedPrintableGroupTypes.includes(printableGroupType));
  }
  const newDesign = allowedDesigns.find(design => design.id === designId) || allowedDesigns.find(design => design.default) || allowedDesigns[0];
  if (!newDesign) {
    return (0, either_1.left)(new Error('Error when finding design: no matching, default, or allowed design found.'));
  }
  return (0, either_1.right)((0, lodash_clonedeep_1.default)(newDesign));
};
exports.findMatchingOrDefaultDesign = findMatchingOrDefaultDesign;